<template>
    <div v-if="items.length > 0" class="slat-group p-t-2 br p-b-2 m-b-4 expandable" v-bind:class="{'expandable-open': expanded}">
        <div class="slat-group-header row row-full row-middle expand-header">
            <div class="slat-content column">
                <h2 class="f-w-bold f-s-4 m-b-0 cu-p" v-on:click="toggleExpanded">
                    {{ label }}
                </h2>
            </div>
            <div class="slat-aside text-right m-r-4 m-t-2 m-b-2">
                    <button type="button" class="cu-p" v-on:click="toggleExpanded">
                        <span class="i-container i-filled-dark">
                            <!-- /icons/open-alt.svg -->
                            <svg class="icon icon-expand i-size-small m-l-1" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M3.664 7.253L2.336 8.747 12 17.338l9.664-8.59-1.328-1.495L12 14.662z" class="icon"/></svg>
                        </span>
                    </button>
                </div>
        </div>
        <transition name="drip-email-slide">
            <div v-if="expanded" class="slat-group-content p-l-4 p-r-4 p-t-4 m-t-1 p-t-0 expand-content">
                <div class="slat-group-content" v-sortable="{ onUpdate: onUpdate, handle: '.handle' }">
                    <div class="slat m-b-3 slat-draggable" v-for="(offer, index) in items" v-bind:key="offer.encoded_id" v-bind:class="{'m-t-4': index > 0}" v-bind:data-encoded-id="offer.encoded_id">
                        <div class="row row-compress row-middle br p-t-3 p-b-3">
                            <div v-if="items.length > 1" class="slat-controls slat-controls--mini m-vertical-none m-l-2">
                                <span class="m-r-2 i-container i-filled-dark">
                                    <span class="handle">
                                        <!-- /icons/drag.svg -->
                                        <svg class="icon i-size-small inline icon-drag" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g transform="translate(8 3)" fill-rule="evenodd" class="icon"><rect width="3" height="3" rx="1.5"/><rect x="5" width="3" height="3" rx="1.5"/><rect y="5" width="3" height="3" rx="1.5"/><rect x="5" y="5" width="3" height="3" rx="1.5"/><rect y="10" width="3" height="3" rx="1.5"/><rect x="5" y="10" width="3" height="3" rx="1.5"/><rect y="15" width="3" height="3" rx="1.5"/><rect x="5" y="15" width="3" height="3" rx="1.5"/></g></svg>
                                    </span>
                                </span>
                            </div>
                            <div v-if="offer.image && offer.image.length > 0" class="slat-figure column">
                                <div class="block">
                                    <img v-bind:src="resizedImageUrl(offer.image, 'thumb')" v-bind:alt="offer.internal_title" v-original-fallback />
                                </div>
                            </div>
                            <div class="slat-content column">
                                <h4 class="f-w-bold f-s-3 m-b-0">
                                    {{ offer.internal_title }}
                                </h4>
                                <p class="f-s-3 m-0 c-medium-tint">
                                    <span>{{ offerTypeLabel(offer) }}</span>
                                    <span>&nbsp;&bull;&nbsp;</span>
                                    <span>{{ offerLocationLabel(offer) }}</span>
                                </p>
                            </div>
                            <div class="slat-aside text-right m-r-4">
                                <a href="#offer-status" v-on:click.prevent="changeStatus(offer, offer.status === 'enabled' ? 'disabled' : 'enabled')">
                                    <span class="tooltip animate">
                                        <span class="i-container" v-bind:class="{'i-filled-dark': offer.status !== 'enabled', 'i-filled-theme': offer.status === 'enabled'}">
                                            <!-- /icons/s-checked.svg -->
                                            <svg class="icon m-r-2 i-size-tiny" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fill="#6F6FFF" class="icon" d="M7.5 11.5l-.056-.002a1.004 1.004 0 0 1-.726-.373l-2-2.5a1.002 1.002 0 0 1 1.563-1.25l1.302 1.628 5.59-5.591a.999.999 0 1 1 1.414 1.414l-6.38 6.381a.993.993 0 0 1-.707.293z"/><path fill="#6F6FFF" class="icon" d="M7.999 15.058a7.057 7.057 0 0 1-7.05-7.05c0-3.887 3.162-7.049 7.05-7.049 1.391 0 2.737.405 3.895 1.171a1 1 0 1 1-1.104 1.668 5.056 5.056 0 0 0-7.841 4.21c0 2.784 2.266 5.05 5.05 5.05s5.05-2.266 5.05-5.05a1 1 0 1 1 2 0 7.057 7.057 0 0 1-7.05 7.05z"/></svg>
                                        </span>
                                        <span class="tooltip-content tooltip-item tooltip--top">{{ offer.status !== 'enabled' ? trans('Enable') : trans('Disable') }}</span>
                                    </span>
                                </a>
                                <span class="tooltip animate">
                                    <a class="i-container i-filled-dark" v-bind:href="offerEditLink(offer)">
                                        <!-- /icons/s-trash.svg -->
                                        <svg class="icon m-r-2 i-size-small" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M15.7 4.3c-.4-.4-1-.4-1.4 0l-10 10c-.2.2-.3.4-.3.7v4c0 .6.4 1 1 1h4c.3 0 .5-.1.7-.3l10-10c.4-.4.4-1 0-1.4l-4-4zM8.6 18H6v-2.6l6-6 2.6 2.6-6 6zm7.4-7.4L13.4 8 15 6.4 17.6 9 16 10.6z" class="icon"/></svg>
                                    </a>
                                    <span class="tooltip-content tooltip-item tooltip--top">{{ trans('Edit') }}</span>
                                </span>
                                <span class="tooltip animate">
                                    <a class="i-container i-filled-dark" href="#delete-file" v-on:click.prevent="removeOffer(index)">
                                        <!-- /icons/s-trash.svg -->
                                        <svg class="icon i-size-tiny inline" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="#6F6FFF" class="icon"><path d="M14.5 3.38h-3.512C10.923 1.782 9.613.5 8 .5S5.077 1.782 5.012 3.38H1.5a1 1 0 1 0 0 2h13a1 1 0 1 0 0-2zM8 2.5a.99.99 0 0 1 .976.88H7.024A.99.99 0 0 1 8 2.5zm5.499 3.507a1.01 1.01 0 0 0-1.104.884L11.604 14H4.396l-.79-7.109a1 1 0 0 0-1.989.22l.889 7.999A1 1 0 0 0 3.5 16h9a1 1 0 0 0 .994-.89l.889-7.999a1 1 0 0 0-.884-1.104z"/><path d="M7.5 11.5v-4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zm3 0v-4a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0z"/></g></svg>
                                    </a>
                                    <span class="tooltip-content tooltip-item tooltip--top">{{ trans('Remove') }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import Orderable from '../../mixins/Orderable.js';
import { resizedImageUrl } from '../../helpers.js';
import { offerDeleteLink, offerEditLink, offerStatusLink } from '../../routes.js';

export default {
    mixins: [Orderable],
    props: {
        type: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        offers: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            items: this.offers,
            model: 'Kourses\\Models\\PromoOffer',
            expanded: true,
        }
    },
    methods: {
        toggleExpanded() {
            this.expanded = ! this.expanded;
        },
        resizedImageUrl(url, size) {
            return window.Kourses.assetBaseUrl + resizedImageUrl(url, size);
        },
        offerEditLink(offer) {
            return offerEditLink(offer);
        },
        changeStatus(offer, status) {
            offer.status = status;
            if (status === 'enabled') {
                window.axios
                    .put(offerStatusLink(offer))
                    .then((response) => {
                        offer.status = response.data.status;
                    });
            } else {
                window.axios
                    .delete(offerStatusLink(offer))
                    .then((response) => {
                        offer.status = response.data.status;
                    });
            }
        },
        removeOffer(index) {
            this.$dialog.confirm(this.trans("If you delete this promotional offer, you cannot recover it. Are you sure you want to delete it?"), {loader: true})
                .then((dialog) => {
                    window.axios.delete(offerDeleteLink(this.offers[index])).then(() => {
                        this.items.splice(index, 1);
                        dialog.close();
                    });
                });
        },
        offerLocationLabel(offer) {
            if (offer.location === 'homepage') {
                return this.trans('Homepage');
            } else if (offer.location === 'sitewide') {
                return this.trans('Sitewide');
            } else if (offer.location === 'products') {
                return this.trans('Products');
            }

            return this.trans('Course') + ' (' + offer.product.title + ')';
        },
        offerTypeLabel(offer) {
            switch (offer.type) {
                case 'notification_bar':
                    return this.trans('Notification Bar');
                case 'sidebar':
                    return this.trans('Sidebar');
                case 'inline':
                    return this.trans('Inline');
                default:
                    return offer.type;
            }
        },
    },
}
</script>
